import React from 'react';
import { View, ScrollView } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './DeviceFullSpecsContainer.Styles';

const DeviceFullSpecsContainer = ({ data, theme }) => {
  return (
    <ScrollView style={styles.fullSpecsContainer}>
      <View style={styles.fullSpecsItemList}>
        {_map(data, (option, index) => {
          return (
            <View key={`${index}`} style={styles.fullSpecsItem}>
              <VFText i18nKey={option.name} style={styles.fullSpecsName} />
              {_map(option.values, (optionValue, optionValueindex) => {
                return (
                  <View key={`${optionValueindex}`} style={styles.fullSpecsItemValuesContainer}>
                    <View style={styles.fullSpecsItemValuesIcon(theme)} />
                    <VFText i18nKey={optionValue} style={styles.fullSpecsItemValuesTxt} />
                  </View>
                );
              })}
            </View>
          );
        })}
      </View>
    </ScrollView>
  );
};
DeviceFullSpecsContainer.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      values: PropTypes.array.isRequired,
    }),
  ),
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
};
export default DeviceFullSpecsContainer;
